import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { getForBusinessCard } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";
// const id = 1;

export default function CardView() {
  const { id, partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  const [data, setCard] = useState({});
  console.log("data: ", data);

  // useEffect(() => {
  //   getForBusinessCard()
  //     .then((res) => {
  //       console.log(res);
  //       // console.log(res.data.data[0]);
  //       setCard(res.data.data[0]);

  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, []);

  const fetchCard = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    try {
      const res = await getForBusinessCard(id);
      const cardData = res.data.data[0];
      setCard({ ...cardData, index: res.data.data.indexOf(cardData) });
    } catch (err) {
      showToast({
        type: 'error',
        message: err.response.data.message || 'Failed to fetch card. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCard();
  }, [id]);

  const columns = ["Card Number", "Card Image", "Content"];
  
  const rows = [];
  if (data && Object.keys(data).length > 0) {
    for (let i = 1; i <= 8; i++) {
      const img = data[`card_image${i}`];
      const content = data[`content${i}`];
      if ((img && img !== '') || (content && content !== '')) {
        rows.push([
          `Card ${String(i).padStart(2, '0')}`,
          img ? <img src={img} alt={`card ${i}`} width="150" /> : null,
          content
        ]);
      }
    }
  }
  return (
    <>
      {isLoading ? (
        <CmsCircularProgress />
      ) : (
        <ContentWrapper>
          <HomeTitle>Cards Section</HomeTitle>
          <CustomTable columns={columns} rows={rows} isLoading={isLoading}/>
          <ButtonWrapper>
            <Link to={`/${partnerId}/forbusiness`}>
              <Button variant="secondary">Go Back</Button>
            </Link>
            <Link to={`/${partnerId}/forbusiness/card/edit/${id}`}>
              <Button>{Number(id) ? "Edit" : "Add"} card section</Button>
            </Link>
          </ButtonWrapper>
        </ContentWrapper>
      )}  
    </>
  );
}

const ContentWrapper = styled.div`
   @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;



const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
  @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
`;
